import { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import { Spin as Hamburger } from "hamburger-react";
import { Collapse, Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Nav as Navbar, MenuList, MenuIcon } from "./styled";

import managerMenuItems from "./ManagerMenuItems";
import useWindowDimensions from "../../../../../hooks/useWindowDimensions";
import UsuarioContext from "../../../../../context/userContext/context";
import { MdOutlineSettings } from "react-icons/md";

export const ManagerMenu = (props: any): JSX.Element => {
	const history = useHistory();
	const { width } = useWindowDimensions();
	const { user } = useContext(UsuarioContext);
	const [showMenuIconMobile, setShowMenuIconMobile] = useState(true);
	const [menuOpen, setMenuOpen] = useState("");

	useEffect(() => {
		width > 900
			? setShowMenuIconMobile(false)
			: setShowMenuIconMobile(true);
	}, [width]);

	var permissions: any = [
		{
			menus: ["Faturamento", "Materiais", "Configuracoes"],
			subMenus: ["Materiais"],
		},
	];

	if (user.is_superuser) {
		permissions[0].menus.push("Dashboard");
		permissions[0].menus.push("Usuarios");
		permissions[0].menus.push("Assinaturas");
		permissions[0].menus.push("Pedidos");
		permissions[0].menus.push("Relatorios");
		//
		permissions[0].subMenus.push("Usuarios");
		permissions[0].subMenus.push("Assinaturas");
		permissions[0].subMenus.push("FaturamentoAdmin");
		permissions[0].subMenus.push("Cursos");
	}

	if (user.profile_status === "Parceiro") {
		permissions[0].menus.push("PartnerDashboard");
		permissions[0].subMenus.push("FaturamentoParceiro");
	}

	if (!permissions[0].menus) {
		history.push("/login");
		return <></>;
	}

	return (
		<>
			{showMenuIconMobile && (
				<MenuIcon>
					<Hamburger
						rounded
						toggled={props.show}
						toggle={() => props.setShow(!props.show)}
					/>
				</MenuIcon>
			)}
			<Navbar
				show={props.show}
				className="nav-total"
			>
				<MenuList show={props.show}>
					{managerMenuItems.map((item: any, index: number) => (
						<CollapsableListItem
							key={index}
							item={item}
							permissions={permissions}
							isActive={
								window.location.pathname === item.route
									? true
									: false
							}
							iconColor={item.iconColor}
							show={props.show}
							setShow={props.setShow}
							isMobile={showMenuIconMobile}
							isOpen={menuOpen === item.permission ? true : false}
							setMenuOpen={setMenuOpen}
							className={item.className ? item.className : ""}
						/>
					))}
				</MenuList>

				<OverlayTrigger
					placement={"right"}
					overlay={
						props.show ? (
							<></>
						) : (
							<Tooltip id={`tooltip-favorites`}>
								Configurações
							</Tooltip>
						)
					}
				>
					<Nav
						className={`flex-column config-item-nav ${
							!props.show && width < 900 ? "d-none" : ""
						}`}
					>
						<Nav.Item
							className={`d-flex align-items-center mb-2 hoverMenuManager ${
								window.location.pathname === "/manager/settings"
									? "menuActiveManager"
									: ""
							} `}
							onClick={() => {
								history.push("/manager/settings");
								props.setShow(!props.show);
							}}
						>
							<span
								className={`d-flex ${
									props.show ? "mx-3" : "mx-auto"
								}`}
								style={{ fontSize: "20px" }}
							>
								<MdOutlineSettings />
							</span>{" "}
							{props.show && "Configurações"}
						</Nav.Item>
					</Nav>
				</OverlayTrigger>

				{props.children}
			</Navbar>
		</>
	);
};

const CollapsableListItem = (props: any) => {
	const {
		item,
		permissions,
		isActive,
		show,
		setShow,
		isMobile,
		setMenuOpen,
		isOpen,
		className = "",
	} = props;
	const history = useHistory();
	const [showOnHover, setShowOnHover] = useState(false);
	const [routeFirstItem, setRouteFirstItem] = useState<any>("");
	const hasAccess = permissions[0].menus.includes(item.permission);
	const classes = isActive
		? `d-flex align-items-center mb-2 hoverMenuManager menuActiveManager`
		: "d-flex align-items-center mb-2 hoverMenuManager";

	const firstMenuItemRoute = () => {
		if (item.children.length > 0) {
			for (var i = 0; i < item.children.length; i++) {
				if (
					permissions[0].subMenus.includes(
						item.children[i].permission
					)
				) {
					setRouteFirstItem(item.children[i].route);
					break;
				}
			}
		}
	};

	const handleClick = () => {
		if (!isMobile && !show && item.children.length > 0) {
			history.push(routeFirstItem);
			return;
		}

		if (item.route !== "") {
			history.push(item.route);
		}

		if (isMobile && show && item.children.length === 0) {
			setShow(!show);
		}

		if (isOpen) {
			setMenuOpen("");
		} else {
			setMenuOpen(item.permission);
		}
	};

	const handleSubMenuClick = () => {
		if (isMobile) {
			setShow(!show);
		}
	};

	useEffect(() => {
		let hasChildActive = item.children.find(
			(x: any) => x.route === window.location.pathname
		)
			? true
			: false;
		if (hasChildActive) {
			setMenuOpen(item.permission);
		}

		if (item.children.length > 0) {
			firstMenuItemRoute();
		}
	}, []);

	return (
		<>
			{hasAccess && (
				<OverlayTrigger
					placement={"right"}
					overlay={
						item.children.length === 0 ? (
							props.show ? (
								<></>
							) : (
								<Tooltip id={`tooltip-favorites`}>
									{item.name}
								</Tooltip>
							)
						) : (
							<></>
						)
					}
				>
					<Nav
						className={`flex-column ${className}`}
						onMouseEnter={() =>
							!isMobile && !show && setShowOnHover(true)
						}
						onMouseLeave={() =>
							!isMobile && !show && setShowOnHover(false)
						}
					>
						<Nav.Item
							className={classes}
							onClick={() => handleClick()}
							data-testid={`menuItem${item.name}`}
						>
							<span
								className={`d-flex ${
									show ? "mx-3" : "mx-auto"
								}`}
								style={{ fontSize: "20px" }}
							>
								{item.icon}
							</span>{" "}
							{show ? (
								<span className="item-name">{item.name}</span>
							) : (
								""
							)}
							{item.children.length > 0 && show ? (
								<span className="d-flex justify-content-end w-100 mx-3">
									{isOpen ? (
										<FaChevronUp />
									) : (
										<FaChevronDown />
									)}
								</span>
							) : (
								""
							)}
						</Nav.Item>

						{item.children.length > 0 && showOnHover && !show && (
							<div className="div-hover-menu-manager text-white">
								<div className="mb-2 ml-2 mt-2">
									<b>{item.name}</b>
								</div>
								{item.children.map(
									(_item: any, index: number) => (
										<>
											{permissions[0].subMenus.includes(
												_item.permission
											) && (
												<Nav
													key={index}
													className={
														window.location
															.pathname ===
														_item.route
															? `align-items-center hoverMenuManager mb-1 subMenuActiveManager`
															: "align-items-center mb-1 hoverMenuManager"
													}
													onClick={() =>
														history.push(
															_item.route
														)
													}
												>
													<Nav.Item
														style={{
															cursor: "pointer",
															padding: "12px",
															lineHeight: 1,
														}}
													>
														{_item.name}
													</Nav.Item>
												</Nav>
											)}
										</>
									)
								)}
							</div>
						)}

						{show &&
							item.children.map((_item: any, index: number) => (
								<InnerCollapsableItem
									key={index}
									item={_item}
									open={isOpen}
									permissions={permissions}
									onClickMenu={() => handleSubMenuClick()}
									isActive={
										window.location.pathname === _item.route
											? true
											: false
									}
								/>
							))}
					</Nav>
				</OverlayTrigger>
			)}
		</>
	);
};

const InnerCollapsableItem = (props: any) => {
	const history = useHistory();
	const { open, item, permissions, isActive, onClickMenu } = props;
	const hasAccess = permissions[0].subMenus.includes(item.permission);
	const classes = isActive
		? `align-items-center mb-2 hoverMenuManager subMenuActiveManager`
		: "align-items-center mb-2 hoverMenuManager";

	const navigate = () => {
		history.push(item.route);
		onClickMenu();
	};

	return (
		hasAccess && (
			<div
				style={{ padding: "0px 7px", borderRadius: "5px" }}
				onClick={() => navigate()}
			>
				<Collapse in={open}>
					<div>
						<Nav className={classes}>
							<Nav.Item
								className="subItem"
								style={{
									paddingLeft: item.level === 3 ? 30 : 20,
									cursor: "pointer",
								}}
							>
								{item.name}
							</Nav.Item>
						</Nav>
					</div>
				</Collapse>
			</div>
		)
	);
};
